import ScoreBadge from '../../components/ScoreBadge.jsx';
import PanelLoadMore from './PanelLoadMore.jsx';
// T270(6) — the on-demand archived list.
// T220 — Archived panel. The relevance shelf: rows whose job would no longer
// pass today's ingestion gate, hidden from the queue but never deleted and
// always one click from coming back.
//
// It shows WHY each row is here and the per-source breakdown, because the shelf
// is only trustworthy if the operator can audit it. The breakdown is also the
// information he needs to decide about a source himself — 357 of the operator's
// 374 archived rows are one source that publishes every government vacancy in
// Denmark, and whether to keep subscribing to it is his call, not the app's.
export default function ArchivedPanel({ recs, loaded, stats, onRestore, hasMore, loadingMore, onLoadMore, total }) {
  const ids = recs.map((r) => r.id);
  return (
    <section className="mt-8">
      <h2 className="text-xs uppercase tracking-wide text-slate-500">
        Archived
        <span className="ml-2 text-slate-600">({stats?.count ?? recs.length})</span>
      </h2>
      <p className="mt-1 text-xs text-slate-500">
        Not deleted — these no longer match what you told the scanner to look for. Change your target
        roles or locations and they come back on the next sweep.
      </p>
      {(stats?.bySource?.length ?? 0) > 0 && (
        <p className="mt-1 text-xs text-slate-600">
          {stats.bySource.slice(0, 6).map((r) => `${r.source} ${r.count}`).join(' · ')}
        </p>
      )}
      {!loaded ? (
        <p className="mt-3 text-xs text-slate-500">Loading…</p>
      ) : recs.length === 0 ? (
        <p className="mt-3 text-xs text-slate-500">Nothing archived.</p>
      ) : (
        <>
          <div className="mt-3 flex justify-end">
            <button
              type="button"
              onClick={() => onRestore(ids)}
              className="rounded-md border border-slate-700 px-2.5 py-1 text-xs text-slate-300 hover:border-brand-600 hover:text-brand-400"
            >
              Restore all {ids.length} shown
            </button>
          </div>
          <ul className="mt-2 divide-y divide-slate-800 rounded-xl border border-slate-800 bg-slate-900/30">
            {recs.map((r) => (
              <li key={r.id} className="flex flex-wrap items-baseline justify-between gap-3 px-4 py-3 text-sm">
                <div className="min-w-0 flex-1">
                  <p className="truncate">
                    <a
                      href={r.job?.url}
                      target="_blank"
                      rel="noreferrer"
                      className="font-medium text-slate-200 hover:text-brand-400"
                    >
                      {r.job?.title ?? '(no title)'}
                    </a>
                    <span className="text-slate-500"> @ {r.job?.company ?? '?'}</span>
                  </p>
                  {r.archivedReason && (
                    <p className="mt-0.5 text-xs text-slate-500">
                      <em>{r.archivedReason}</em>
                      {r.job?.source ? <span className="text-slate-600"> · {r.job.source}</span> : null}
                    </p>
                  )}
                </div>
                <ScoreBadge
                  score={r.scoreTotal}
                  breakdown={r.scoreBreakdown}
                  reasons={r.reasons}
                  risks={r.risks}
                  missingSkills={r.missingSkills}
                  variant="compact"
                />
                <button
                  type="button"
                  onClick={() => onRestore([r.id])}
                  className="rounded-md border border-slate-700 px-2.5 py-1 text-xs text-slate-300 hover:border-brand-600 hover:text-brand-400"
                >
                  Restore
                </button>
              </li>
            ))}
          </ul>
          <PanelLoadMore
            shown={recs.length}
            total={total || stats?.count || recs.length}
            hasMore={hasMore}
            loading={loadingMore}
            onLoadMore={onLoadMore}
          />
        </>
      )}
    </section>
  );
}
